// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MXka9","logo":"styles_logo__Gj1KF","logo-devider":"styles_logo-devider__oHYkV","img":"styles_img__lBuSZ","text-block":"styles_text-block__qBGYi"};